import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography } from "antd";
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';  
import { list } from "../../../controllers/V1/cms/campaignController";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";

const VendorListDeletePopUp = ({ popUpOpen, togglePopUp }) => {
  const handleCancel = () => togglePopUp();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExport = async (e) => {
    e.preventDefault(); // Prevent the default form submission

    setError(null); // Reset the error state before each request
    try {
      setIsLoading(true);
      const formData = new FormData(e.target);


      const option = {
        isExport : true,
        condition: {
          ...(formData.get("title") && { title: formData.get("title") } ),
          ...(formData.get("category") && { category: { $regex: formData.get("category"), $options: "i" } } ),
          ...(formData.get("sub_category") && { sub_category:  { $regex: formData.get("sub_category"), $options: "i" } } ),
          ...(formData.get("straight_add_on_amount") && { straight_add_on_amount: parseInt(formData.get("straight_add_on_amount"),) } ),
          ...(formData.get("rumble_add_on_amount") && { rumble_add_on_amount: parseInt(formData.get("rumble_add_on_amount"),) } ),
          ...(formData.get("chance_add_on_amount") && { chance_add_on_amount: parseInt(formData.get("chance_add_on_amount"),) } ),
          ...(formData.get("enable_number_range_prefix") && { enable_number_range_prefix: parseInt(formData.get("enable_number_range_prefix"),) } ),
          ...(formData.get("ticket_number_repeat") && { ticket_number_repeat: parseInt(formData.get("ticket_number_repeat"),) } ),

          ...(formData.get("valid_date") && { valid_date: new Date(formData.get("valid_date")) } ),
          ...(formData.get("expire_date") && { expire_date: new Date(formData.get("expire_date")) } ),
        },
        select: {
          ...(formData.get("select_title") && { title: true } ),
          ...(formData.get("select_sub_category") && { sub_category: true } ),
          ...(formData.get("select_category") && { category: true } ),
          ...(formData.get("select_straight_add_on_amount") && { straight_add_on_amount: true } ),
          ...(formData.get("select_rumble_add_on_amount") && { rumble_add_on_amount: true } ),
          ...(formData.get("select_chance_add_on_amount") && { chance_add_on_amount: true } ),
        //   ...(formData.get("select_points") && { points: true } ),

          ...(formData.get("select_select_draw_date_time") && { select_draw_date_time: true } ),
          // ...(formData.get("select_expire_date") && { expire_date: true } ),
        },
      };

      // Make the API call
      const res = await list(option);
      if (res.status === true) {
        await exportToExcel(res.result); // Export the results to Excel
        handleCancel(); // Reset the form or close modal
      } else {
        setIsLoading(false);
        setError("No records found matching the criteria.");
      }
    } catch (error) {
      setIsLoading(false);
      setError("An error occurred while exporting the data.");
      console.error("Export Error:", error);
    }
  };

  const exportToExcel = async (data) => {
    try {
      const workbook = XLSX.utils.book_new();
      const worksheet1 = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet1, "Due");
      XLSX.writeFile(workbook, `${new Date()}.xlsx`);
    } catch (error) {
      alert("Error generating Excel file: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography variant="h5" component="div" gutterBottom className="inventory_popup_title_heading">
            Export Campaign
          </Typography>
          <Link to={false} style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }} onClick={handleCancel}>
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>
        <Typography variant="body1" component="div" className="my_delete_popup_paragraph">
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <form onSubmit={handleExport}>
                <div className="form-group row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="title" className="all_lable_for_vendor_dashbaord">Title :</label>
                    <input type="text" name="title" id="title" placeholder="Title" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="category" className="all_lable_for_vendor_dashbaord">Category :</label>
                    <input type="text" name="category" id="category" placeholder="Category" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="sub_category" className="all_lable_for_vendor_dashbaord">Sub Category :</label>
                    <input type="text" name="sub_category" id="sub_category" placeholder="Sub Category" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="straight_add_on_amount" className="all_lable_for_vendor_dashbaord">Straight Points :</label>
                    <input type="text" name="straight_add_on_amount" id="straight_add_on_amount" placeholder="Straight Points" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="rumble_add_on_amount" className="all_lable_for_vendor_dashbaord">Rumble Points :</label>
                    <input type="text" name="rumble_add_on_amount" id="rumble_add_on_amount" placeholder="Rumble Points" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="chance_add_on_amount" className="all_lable_for_vendor_dashbaord">Chance Points :</label>
                    <input type="text" name="chance_add_on_amount" id="chance_add_on_amount" placeholder="Chance Points" className="form-control categories_select_tg_enter_product" />
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="select_title" className="all_lable_for_vendor_dashbaord" > Date specific (If any) :</label>
                    </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="valid_date" className="all_lable_for_vendor_dashbaord">From :</label>
                    <input type="date" name="valid_date" id="valid_date" className="form-control categories_select_tg_enter_product" />
                  </div>

                  <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="expire_date" className="all_lable_for_vendor_dashbaord">To :</label>
                    <input type="date" name="expire_date" id="expire_date" className="form-control categories_select_tg_enter_product" />
                  </div>

                  {/* <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <label htmlFor="points" className="all_lable_for_vendor_dashbaord">Points :</label>
                    <input type="number" name="points" id="points" placeholder="Points" className="form-control categories_select_tg_enter_product" />
                  </div> */}

                  {/* Selection Checkboxes for Export */}
                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label for="select_title" className="all_lable_for_vendor_dashbaord" > Export fields (If any) : </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_title" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_title" id="select_title" className="form-check-input" /> Title
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_category" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_category" id="select_category" className="form-check-input" /> Category
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_sub_category" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_sub_category" id="select_sub_category" className="form-check-input" /> Sub Category
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_straight_add_on_amount" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_straight_add_on_amount" id="select_straight_add_on_amount" className="form-check-input" /> Straight Points
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_rumble_add_on_amount" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_rumble_add_on_amount" id="select_rumble_add_on_amount" className="form-check-input" /> Rumble Points
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_chance_add_on_amount" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_chance_add_on_amount" id="select_chance_add_on_amount" className="form-check-input" /> Chance Points 
                      </label>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_draw_date_time" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_draw_date_time" id="select_draw_date_time" className="form-check-input" /> Draw Date & Time
                      </label>
                    </div>
                    {/* <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                      <label for="select_expiry_date" className="all_lable_for_vendor_dashbaord" > 
                        <input type="checkbox" name="select_expire_date" id="select_expire_date" className="form-check-input" /> Expire Date
                      </label>
                    </div> */}
  

                  <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="inventory_open_popup_action_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={handleCancel}>Cancel</button>
                      <button type="submit" className="btn btn-danger" disabled={isLoading}>Download Excel</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Typography>
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default VendorListDeletePopUp;
